import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Alert, Spin } from "antd";
import useGlobalHandler from "../../hooks/useGlobalHandler";
import { resetPassword } from "../../hooks/useSignup";
import { useTranslation } from "react-i18next";

const ForgetPasswordForm = () => {
  const { t } = useTranslation("preAuth");
  const navigate = useNavigate();
  const {
    isLoading,
    setIsLoading,
    isError,
    setIsError,
    error,
    setError,
    success,
    setSuccess,
  } = useGlobalHandler();
  const [email, setEmail] = useState("");
  const handelSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      setIsError(false);
      setError("");
      await resetPassword(email);
      setIsLoading(false);
      setSuccess(t("email sent, check your inbox"));
      setTimeout(() => {
        navigate("/auth/login");
      }, 5000);
    } catch (error) {
      setIsError(true);
      setError("faild to send email, try again");
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white py-10 px-8 rounded-lg md:w-1/3 min-w-[94%] md:min-w-max">
      <form className="flex flex-col gap-4  " onSubmit={handelSubmit}>
        <div className="flex flex-col gap-1">
          <h1 className="LoginTtitle">{t(`reset password`)}</h1>
          <p className="font-light text-[#404040] max-w-80">
            {t(`enter your email to receive reset password email`)}
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <label className="text-primaryColor">{t(`email`)} </label>
          <input
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            type="email"
            className="border-2 rounded-md p-1"
            placeholder={t(`email`)}
          />

          {isError && <Alert message={error} type="error" />}
          {success && <Alert message={success} type="success" />}
        </div>
        <div className="flex flex-col gap-1">
          <motion.button
            whileTap={{ scale: 0.9 }}
            whileHover={{ scale: 1.05 }}
            className="primaryLoginButton"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? <Spin /> : t("send email")}
          </motion.button>
        </div>
        <p className="self-center">
          {t("click")}{" "}
          <Link
            to="/auth/login"
            className="underline underline-offset-1 text-primaryColor"
          >
            {t("here")}
          </Link>{" "}
          {t("to go back to login page")}{" "}
        </p>
      </form>
    </div>
  );
};

export default ForgetPasswordForm;
